import React from 'react';

import RenderInDomNode from 'components/Pages/Admin/Page/common/RenderInStuff';

import EditorBlockBar from './EditorBlockBar';

const withPortalResolver =
  (Component) =>
  ({ mountId, ...props }) => {
    if (!mountId) return <Component {...props} />;

    return (
      <RenderInDomNode id={mountId}>
        <Component {...props} />
      </RenderInDomNode>
    );
  };

export default withPortalResolver(EditorBlockBar);
